import { render } from "./Galery.vue?vue&type=template&id=a3702e3e&scoped=true"
import script from "./Galery.vue?vue&type=script&lang=js"
export * from "./Galery.vue?vue&type=script&lang=js"

import "./Galery.vue?vue&type=style&index=0&id=a3702e3e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a3702e3e"

export default script